import { render, staticRenderFns } from "./CurrencyWithdraw.vue?vue&type=template&id=0c2ffdd0&scoped=true&lang=html&"
import script from "./CurrencyWithdraw.vue?vue&type=script&lang=js&"
export * from "./CurrencyWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyWithdraw.vue?vue&type=style&index=0&id=0c2ffdd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ffdd0",
  null
  
)

export default component.exports